import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import companies from "../../services/companies.js";

class JobblerController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    ProfileService,
    EventsService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout,
    $location,
    $scope,
    JobsService
  ) {
    this.name = "jobbler";
    $localStorage.activeStateName = "jobbler";
    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$profile = ProfileService;
    this.$common = CommonService;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.$jobs = JobsService;
    this.remain_loading_count = 0;
    this.currentUser = this.$auth.getUserData();
    this.jobbler_data = {};
    this.profile_not_complete = true;
    this.jobbler_data.first_name = this.currentUser.firstName;
    this.jobbler_data.last_name = this.currentUser.lastName;
    var _this = this;

    _this.setActiveTab();
    this.userProfileStatus = this.$profile.getUserProfileStatus(this.currentUser);
    this.jobTypesCompleted =
      this.currentUser && this.currentUser.notifPref && this.currentUser.notifPref.jobbleTypes && this.currentUser.notifPref.jobbleTypes.length !== 0;

    if (!_this.$localStorage.logged_user.prof_image) {
      _this.getProfilePicture();
    }

    this.SetProfileImageForJobblerListener = this.$rootScope.$on("SetProfileImageForJobbler", function ($event, params) {
      _this.jobbler_data = params.user;
      _this.getProfilePicture();
    });

    this.SetCoverImageForJobblerListener = this.$rootScope.$on("SetCoverImageForJobbler", function ($event, params) {
      _this.cover_photo = params.image;
      _this.getProfilePicture();
    });

    this.SettingNewUserDataToParentListener = this.$rootScope.$on("SettingNewUserDataToParent", function ($event, params) {
      _this.currentUser = params;
    });

    this.ProfileStatusCheckListener = this.$rootScope.$on("ProfileStatusCheck", ($event, params) => {
      console.log("ProfileStatusCheckListener");
      console.dir(params);
      this.check_status_for_banking_tab(params);

      this.$jobs.canUserApplyToShiftBasedJobs().then((response) => {
        console.log("Most recent user");
        console.dir(response.data);

        this.currentUser = response.data;
        this.userProfileStatus = this.$profile.getUserProfileStatus(this.currentUser);
        this.jobTypesCompleted =
          this.currentUser &&
          this.currentUser.notifPref &&
          this.currentUser.notifPref.jobbleTypes &&
          this.currentUser.notifPref.jobbleTypes.length !== 0;
      });
    });

    _this.$scope.$on("$destroy", _this.SettingNewUserDataToParentListener);
    _this.$scope.$on("$destroy", _this.SetProfileImageForJobblerListener);
    _this.$scope.$on("$destroy", _this.SetCoverImageForJobblerListener);
    //console.log("state params");
    //console.dir(_this.$stateParams);
    if (_this.$stateParams.job && _this.$stateParams.check_user === true) {
      _this.checkUserForFields();
    }

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  getProfilePicture() {
    this.$profile.getProfilePicture(this.currentUser.access_token).then(
      (response) => {
        console.log("get profile picture response");
        console.dir(response);

        this.unSetLoader();

        this.$timeout(() => {
          if (response.data.picture1) {
            this.jobbler_data.image = response.data.picture1;
            this.$localStorage.logged_user.prof_image = response.data.picture1;
          } else {
            this.jobbler_data.image = "/app/vendor/images/defaultimg.jpeg";
            this.$localStorage.logged_user.prof_image = "/app/vendor/images/defaultimg.jpeg";
          }
          if (response.data.resumeLink) {
            this.resume_url = response.data.resumeLink;
          } else if (response.data.resumeLink2) {
            this.resume_url = response.data.resumeLink2;
            this.$localStorage.logged_user.resumeLink = response.data.resumeLink2;
          }
          if (response.data.picture2) {
            this.jobbler_data.cover_photo = response.data.picture2;
            this.$localStorage.logged_user.cover_photo = response.data.picture2;
          } else {
            this.jobbler_data.cover_photo = "/app/vendor/images/default-cover-photo.jpg";
            this.$localStorage.logged_user.cover_photo = "/app/vendor/images/default-cover-photo.jpg";
          }
        });
      },
      function (error) {
        //console.log("in error");
        //console.dir(error);
      }
    );
  }

  findPage() {
    var _this = this;
    let path = _this.$location.$$path;
    let page = null;
    if (path.indexOf("gallery") > -1) {
      page = 2;
    } else if (path.indexOf("banking") > -1) {
      page = 4;
    } else if (path.indexOf("social") > -1) {
      page = 3;
    } else {
      page = 1;
    }
    _this.setActiveTab(page);
  }

  validate_basic_prof() {
    var _this = this;

    console.log("validate_basic_prof");
    console.dir(_this.currentUser);
  }

  setMobileActiveTab(page) {
    if (page === 4 && this.profile_not_complete === true) {
      alert("Before you can add your payment settings, make sure to input your personal details first.");
      return;
    }

    this.page = page;
  }

  setActiveTab(page) {
    var _this = this;

    let path = this.$location.$$path;

    if (path.indexOf("gallery") > -1) {
      this.page = 2;
    } else if (path.indexOf("banking") > -1) {
      this.page = 4;
    } else if (path.indexOf("social") > -1) {
      this.page = 3;
    } else if (path.indexOf("preferences") > -1) {
      this.page = 5;
    } else {
      if (page === 4 && this.profile_not_complete) {
        // alert("Before you add your banking information please fill in your : " + _this.error_string);
      } else {
        this.page = 1;
      }
    }
  }

  uploadProfilePhoto() {
    console.log("Uploading photo");

    let file = $("#profile-photo-upload")[0].files[0];
    console.log(file);
    const fd = new FormData();
    fd.append("file", file);
    console.log(fd);

    this.setLoader();

    this.$profile.uploadProfilePicture(fd).then((res) => {
      console.log("photo rest", res);
      if (res.status === 200) {
        this.getPhotos(true);
      }
    });
  }

  getPhotos(is_profile_picture, init, is_cover_photo, is_edit) {
    this.$profile.getMultiMediaDataWithFormats().then(
      (response) => {
        this.setMultiMediaData(response.data, is_profile_picture, init, is_cover_photo, is_edit);
      },
      function (error) {
        alert("Error grabbing multimedia");
      }
    );
  }

  setMultiMediaData(user, is_profile_picture, init, is_cover_photo, is_edit) {
    let data_model = {};
    data_model.picture_data = this.$profile.getJobblerPictures(user, is_edit, this.model);
    this.model = data_model;

    let left_rail_data = {};

    left_rail_data.image = this.model.picture_data.main_picture;
    left_rail_data.image_only = true;
    left_rail_data.first_name = this.currentUser.firstName;
    left_rail_data.last_name = this.currentUser.lastName;

    this.$auth.refreshCurrentUser().then(() => {
      this.$timeout(() => {
        this.currentUser = this.$auth.getUserData();
        this.$rootScope.imgFromProfilePage = this.model.picture_data.main_picture;
        this.$rootScope.$emit("SetProfileImageForJobbler", {
          user: left_rail_data,
        });
        this.getProfilePicture();
      });
    });
  }

  resumeModal() {
    var _this = this;
    console.log("in resume modal");
    let user = _this.currentUser;
    _this.$timeout(function () {
      $("#resume-upload-modal").modal();
      _this.$rootScope.$emit("SetResumeData", {user});
    });
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  checkUserForFields() {
    var _this = this;
    let job = _this.$stateParams.job;
    let user = _this.currentUser;

    //console.log("checkUserforFields");
    //console.dir(job);
    //console.dir(user);
    if (
      user.dateBirth &&
      user.homeContactInfo.phoneMobile &&
      user.ssn &&
      user.homeContactInfo.zipCode &&
      user.homeContactInfo.city &&
      user.homeContactInfo.streetLine1 &&
      user.homeContactInfo.state
    ) {
      if (!user.profilePictureUri) {
        _this.$state.go("jobblergallery", {
          job,
          user,
          display_warning: true,
        });
      } else {
        //console.log("this means we have all the data and can go to the job page....");
      }
    } else {
      //console.log("set the job for basic");
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetJobForApplicationAfterBasicFilled", {
          job,
        });
      });
    }
  }

  check_status_for_banking_tab(data) {
    var _this = this;

    let x = data.error_model;

    console.log("check_status_for_banking_tab");
    console.dir(x);

    if (x.phone === true || x.ssn === true || x.address1 === true || x.city === true || x.state === true || x.month === true) {
      _this.error_string = "";
      _this.profile_not_complete = true;
      if (x.phone === true) {
        _this.error_string = _this.error_string + "Phone, ";
      }
      if (x.ssn === true) {
        _this.error_string = _this.error_string + "Social Security Number, ";
      }
      if (x.address1 === true) {
        _this.error_string = _this.error_string + "Address, ";
      }
      if (x.month === true) {
        _this.error_string = _this.error_string + "Date of birth, ";
      }

      let len = _this.error_string.length;
      let len2 = len - 2;
      _this.error_string = _this.error_string.substring(0, len2);
    } else {
      _this.profile_not_complete = false;
    }
  }
}

JobblerController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "profile",
  "events",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
  "$location",
  "$scope",
  "jobs",
];

export default JobblerController;



// WEBPACK FOOTER //
// ./client/app/components/jobbler/jobbler.controller.js